// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ——— Patient profile (Stitch Clinical Precision) ——— */
.patient-profile {
  box-sizing: border-box;
  width: 100%;
  padding: 32px;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 0;
}

.patient-profile__hero {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  flex-wrap: wrap;
  padding-bottom: 24px;
  border-bottom: 1px solid #E2E8F0;
}

.patient-profile__hero-left {
  display: flex;
  align-items: center;
  gap: 16px;
  min-width: 0;
}

.patient-profile__avatar-wrap {
  position: relative;
  flex-shrink: 0;
}

.patient-profile__avatar {
  width: 56px;
  height: 56px;
  border-radius: 9999px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #E0F2FE;
  color: #0EA5E9;
  font-size: 18px;
  font-weight: 700;
  border: 2px solid #ffffff;
  box-shadow: 0 0 0 2px #BAE6FD;
}

.patient-profile__avatar-dot {
  position: absolute;
  right: 0;
  bottom: 0;
  width: 14px;
  height: 14px;
  border-radius: 9999px;
  background: #10B981;
  border: 2px solid #ffffff;
}

.patient-profile__hero-text {
  min-width: 0;
}

.patient-profile__title-row {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
}

.patient-profile__name {
  margin: 0;
  font-size: 24px;
  font-weight: 700;
  letter-spacing: -0.02em;
  color: #0F172A;
  line-height: 1.2;
}

.patient-profile__active {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  height: 22px;
  padding: 0 10px;
  border-radius: 9999px;
  border: 1px solid #A7F3D0;
  background: #ECFDF5;
  color: #047857;
  font-size: 12px;
  font-weight: 500;
}

.patient-profile__active-dot {
  width: 6px;
  height: 6px;
  border-radius: 9999px;
  background: #10B981;
}

.patient-profile__meta {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 6px;
  margin-top: 4px;
  font-size: 13px;
  color: #64748B;
}

.patient-profile__meta-sep {
  color: #94A3B8;
}

.patient-profile__meta-mono {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;
  font-weight: 500;
  color: #334155;
  font-variant-numeric: tabular-nums;
}

.patient-profile__meta-place {
  display: inline-flex;
  align-items: center;
  gap: 4px;
}

.patient-profile__meta-place .anticon {
  color: #94A3B8;
  font-size: 15px;
}

.patient-profile__hero-actions {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
  flex-shrink: 0;
}

.patient-profile__btn {
  box-sizing: border-box;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  height: 36px;
  padding: 0 14px;
  border-radius: 8px;
  font-size: 13px;
  font-weight: 600;
  font-family: inherit;
  cursor: pointer;
  white-space: nowrap;
  transition: background 0.12s ease, border-color 0.12s ease, color 0.12s ease;
}

.patient-profile__btn--sm {
  height: 32px;
  padding: 0 12px;
  font-size: 12px;
}

.patient-profile__btn--secondary {
  border: 1px solid #E2E8F0;
  background: #ffffff;
  color: #334155;
}

.patient-profile__btn--secondary:hover {
  background: #F8FAFC;
  border-color: #CBD5E1;
}

.patient-profile__btn--soft {
  border: 1px solid #BAE6FD;
  background: #F0F9FF;
  color: #0EA5E9;
}

.patient-profile__btn--soft:hover {
  background: #E0F2FE;
}

.patient-profile__btn--primary {
  border: 1px solid #0EA5E9;
  background: #0EA5E9;
  color: #ffffff;
}

.patient-profile__btn--primary:hover {
  background: #0284C7;
  border-color: #0284C7;
}

.patient-profile__cards {
  display: grid;
  grid-template-columns: minmax(0, 2fr) minmax(0, 3fr);
  gap: 20px;
  padding: 24px 0;
}

@media (max-width: 960px) {
  .patient-profile {
    padding: 16px;
  }

  .patient-profile__cards {
    grid-template-columns: 1fr;
  }
}

.patient-profile__card {
  box-sizing: border-box;
  background: #ffffff;
  border: 1px solid #E2E8F0;
  border-radius: 12px;
  padding: 20px;
  min-width: 0;
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04);
}

.patient-profile__card-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding-bottom: 14px;
  margin-bottom: 14px;
  border-bottom: 1px solid #F1F5F9;
}

.patient-profile__card-title {
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 0;
}

.patient-profile__card-title h2 {
  margin: 0;
  font-size: 14px;
  font-weight: 600;
  color: #0F172A;
}

.patient-profile__card-icon {
  width: 28px;
  height: 28px;
  border-radius: 8px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  font-size: 14px;
}

.patient-profile__card-icon.is-sky {
  background: #F0F9FF;
  color: #0EA5E9;
}

.patient-profile__card-icon.is-rose {
  background: #FFF1F2;
  color: #E11D48;
}

.patient-profile__card-icon.is-emerald {
  background: #ECFDF5;
  color: #059669;
}

.patient-profile__card-badge {
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: #94A3B8;
  white-space: nowrap;
}

.patient-profile__rows {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.patient-profile__row {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 16px;
  font-size: 13px;
}

.patient-profile__row-label {
  color: #64748B;
  flex-shrink: 0;
}

.patient-profile__row-value {
  font-weight: 500;
  color: #0F172A;
  text-align: end;
  min-width: 0;
  word-break: break-word;
}

.patient-profile__multiline {
  white-space: pre-wrap;
  overflow-wrap: anywhere;
  word-break: break-word;
}

.patient-profile__clinical {
  display: flex;
  flex-direction: column;
  gap: 16px;
  min-width: 0;
}

.patient-profile__vitals {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 16px;
  min-width: 0;
}

.patient-profile__vital-value {
  margin: 0;
  font-size: 14px;
  font-weight: 600;
  color: #0F172A;
}

.patient-profile__clinical-pair {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 16px;
  min-width: 0;
  align-items: stretch;
}

.patient-profile__clinical-block {
  display: flex;
  flex-direction: column;
  gap: 8px;
  min-width: 0;
}

@media (max-width: 640px) {
  .patient-profile__vitals,
  .patient-profile__clinical-pair {
    grid-template-columns: 1fr;
  }
}

.patient-profile__clinical-label {
  font-size: 12px;
  font-weight: 500;
  color: #94A3B8;
}

.patient-profile__clinical-empty {
  margin: 0;
  font-size: 13px;
  font-weight: 500;
  color: #94A3B8;
}

.patient-profile__row-value.is-mono,
.patient-profile__mono {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;
  font-variant-numeric: tabular-nums;
  font-weight: 500;
  color: #334155;
}

.patient-profile__mono.is-strong {
  color: #0F172A;
}

.patient-profile__row-value.is-muted {
  color: #94A3B8;
  font-weight: 500;
}

.patient-profile__row-value.is-chip {
  flex-shrink: 0;
  padding: 2px 8px;
  border-radius: 6px;
  border: 1px solid #E2E8F0;
  background: #F8FAFC;
  font-size: 12px;
  color: #0F172A;
}

.patient-profile__alert {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  width: 100%;
  box-sizing: border-box;
  min-width: 0;
  padding: 10px 12px;
  border-radius: 8px;
  border: 1px solid #FDE68A;
  background: #FFFBEB;
  color: #B45309;
  font-size: 12px;
  font-weight: 500;
  line-height: 1.5;
}

.patient-profile__alert-text {
  margin: 0;
}

.patient-profile__alert-dot {
  width: 6px;
  height: 6px;
  margin-top: 6px;
  border-radius: 9999px;
  background: #F59E0B;
  flex-shrink: 0;
}

.patient-profile__med-block {
  width: 100%;
  box-sizing: border-box;
  min-width: 0;
  margin: 0;
  padding: 10px 12px;
  border-radius: 8px;
  border: 1px solid #E2E8F0;
  background: #F8FAFC;
  color: #0F172A;
  font-size: 12px;
  font-weight: 500;
  line-height: 1.5;
}

.patient-profile__clamp {
  flex: 1 1 auto;
  min-width: 0;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 6px;
}

.patient-profile__clamp-body {
  margin: 0;
  max-height: 3em; /* ~2 lines at 1.5 line-height */
  overflow: hidden;
}

.patient-profile__clamp-body.is-expanded {
  max-height: none;
  overflow: visible;
}

.patient-profile__clamp-toggle {
  border: 0;
  padding: 0;
  background: transparent;
  color: #0EA5E9;
  font-size: 12px;
  font-weight: 700;
  font-family: inherit;
  cursor: pointer;
  line-height: 1.2;
  text-decoration: underline;
  text-underline-offset: 2px;
}

.patient-profile__clamp-toggle:hover {
  color: #0284C7;
}

.patient-profile__alert .patient-profile__clamp-toggle {
  color: #D97706;
}

.patient-profile__alert .patient-profile__clamp-toggle:hover {
  color: #B45309;
}

.patient-profile__notes {
  padding-top: 8px;
  border-top: 1px solid #F1F5F9;
}

.patient-profile__notes-label {
  display: block;
  margin-bottom: 6px;
  font-size: 12px;
  font-weight: 500;
  color: #94A3B8;
}

.patient-profile__notes-body {
  padding: 10px;
  border-radius: 8px;
  border: 1px solid #F1F5F9;
  background: #F8FAFC;
  font-size: 12px;
  line-height: 1.5;
  color: #334155;
  white-space: pre-wrap;
}

/* Tabs — Stitch underline bar, not the shared Ant tab chrome */
.patient-profile__tabs {
  min-width: 0;
  padding-top: 8px;
}

.patient-profile__tabbar {
  display: flex;
  align-items: flex-end;
  gap: 24px;
  margin-bottom: 20px;
  border-bottom: 1px solid #E2E8F0;
  overflow-x: auto;
  overflow-y: hidden;
}

.patient-profile__tabbar > button {
  appearance: none;
  margin: 0 0 -1px;
  padding: 0 0 12px;
  border: 0;
  border-bottom: 2px solid transparent;
  background: transparent;
  color: #64748B;
  font-family: inherit;
  font-size: 14px;
  font-weight: 500;
  line-height: 1.25;
  white-space: nowrap;
  cursor: pointer;
}

.patient-profile__tabbar > button:hover {
  color: #1E293B;
}

.patient-profile__tabbar > button.is-active {
  color: #0EA5E9;
  font-weight: 600;
  border-bottom-color: #0EA5E9;
}

.patient-profile__tab-label {
  display: inline-flex;
  align-items: center;
  gap: 8px;
}

.patient-profile__tab-badge {
  display: inline-flex;
  align-items: center;
  padding: 2px 8px;
  border-radius: 9999px;
  background: #F1F5F9;
  color: #475569;
  font-size: 11px;
  font-weight: 500;
  line-height: 1.3;
  letter-spacing: 0;
  text-transform: none;
}

.patient-profile__tabbar > button.is-active .patient-profile__tab-badge {
  background: #E0F2FE;
  color: #0369A1;
  font-weight: 600;
}

.patient-profile__tab-panel {
  min-width: 0;
}

.patient-profile__tab-panel[hidden] {
  display: none;
}

/* Tab panels / tables */
.patient-profile__panel {
  background: #ffffff;
  border: 1px solid #E2E8F0;
  border-radius: 12px;
  overflow: hidden;
  min-width: 0;
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04);
}

.patient-profile__panel-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  flex-wrap: wrap;
  padding: 16px;
  border-bottom: 1px solid #F1F5F9;
  background: rgba(248, 250, 252, 0.7);
}

.patient-profile__panel-title {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
  min-width: 0;
}

.patient-profile__panel-title h3 {
  margin: 0;
  font-size: 14px;
  font-weight: 600;
  color: #0F172A;
}

.patient-profile__panel-title .patient-profile__card-icon {
  width: 32px;
  height: 32px;
}

.patient-profile__count-pill {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  height: 22px;
  padding: 0 8px;
  border-radius: 9999px;
  border: 1px solid #A7F3D0;
  background: #ECFDF5;
  color: #047857;
  font-size: 11px;
  font-weight: 600;
  white-space: nowrap;
}

.patient-profile__count-pill .patient-profile__status-dot {
  background: #10B981;
}

.patient-profile__panel-tools {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
}

.patient-profile__panel-search {
  position: relative;
}

.patient-profile__panel-search-icon {
  position: absolute;
  inset-inline-start: 10px;
  top: 50%;
  transform: translateY(-50%);
  color: #94A3B8;
  font-size: 14px;
  z-index: 1;
  pointer-events: none;
}

.patient-profile__panel-search-input.ant-input,
.patient-profile__panel-search-input.ant-input-affix-wrapper {
  width: 200px;
  height: 32px !important;
  padding-inline-start: 30px !important;
  border-radius: 6px !important;
  border-color: #E2E8F0 !important;
  font-size: 12px;
}

.patient-profile__panel-body {
  min-height: 80px;
}

.patient-profile__empty {
  padding: 32px 20px;
  text-align: center;
  color: #94A3B8;
}

.patient-profile__empty p {
  margin: 8px 0 0;
  font-size: 13px;
  font-weight: 500;
}

.patient-profile__table-scroll {
  width: 100%;
  overflow-x: auto;
}

.patient-profile__table {
  display: grid;
  width: 100%;
  min-width: 760px;
  font-size: 13px;
}

.patient-profile__table.is-visits {
  grid-template-columns: 88px minmax(140px, 1.1fr) minmax(160px, 1.2fr) minmax(160px, 1fr) 130px 110px;
}

.patient-profile__table.is-packages {
  grid-template-columns: 100px minmax(140px, 1.4fr) 120px 90px 90px 88px;
}

.patient-profile__table.is-journeys {
  grid-template-columns: 88px minmax(160px, 1.1fr) minmax(180px, 1.2fr) 140px 130px;
}

.patient-profile__table.is-ledger {
  grid-template-columns: repeat(6, minmax(0, 1fr));
  min-width: 920px;
  gap: 0;
}

.patient-profile__table.is-ledger .patient-profile__table-head > div {
  min-height: 36px;
  padding: 8px 16px;
}

.patient-profile__table.is-ledger .patient-profile__table-row {
  cursor: default;
}

.patient-profile__table.is-ledger .patient-profile__table-row > div {
  min-height: 40px;
  padding: 8px 16px;
  line-height: 1.3;
}

.patient-profile__table.is-ledger .patient-profile__table-head > div:nth-child(3),
.patient-profile__table.is-ledger .patient-profile__table-row > div.is-amount {
  justify-content: flex-end;
  white-space: nowrap;
  font-variant-numeric: tabular-nums;
}

.patient-profile__table.is-ledger .is-amount-value {
  white-space: nowrap;
  display: inline-block;
}

.patient-profile__table.is-ledger .patient-profile__table-head > div:nth-child(4),
.patient-profile__table.is-ledger .patient-profile__table-row > div.is-type,
.patient-profile__table.is-ledger .patient-profile__table-head > div:nth-child(5),
.patient-profile__table.is-ledger .patient-profile__table-row > div.is-status {
  justify-content: center;
}

.patient-profile__table.is-ledger .patient-profile__table-head > div:nth-child(6),
.patient-profile__table.is-ledger .patient-profile__table-row > div.is-action {
  justify-content: flex-end;
  padding-inline-end: 16px;
}

.patient-profile__table-row.is-highlight > div {
  background: rgba(255, 251, 235, 0.55);
}

.patient-profile__table-row.is-highlight:hover > div {
  background: #FFFBEB;
}

.patient-profile__table-head,
.patient-profile__table-row {
  display: grid;
  grid-template-columns: subgrid;
  grid-column: 1 / -1;
}

.patient-profile__table-head {
  border-bottom: 1px solid #F1F5F9;
  background: rgba(248, 250, 252, 0.85);
}

.patient-profile__table-head > div {
  display: flex;
  align-items: center;
  min-height: 36px;
  padding: 8px 16px;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: #64748B;
}

.patient-profile__table-row {
  cursor: pointer;
  border-bottom: 1px solid #F1F5F9;
}

.patient-profile__table-row:last-child {
  border-bottom: 0;
}

.patient-profile__table-row > div {
  display: flex;
  align-items: center;
  min-height: 44px;
  padding: 8px 16px;
  color: #334155;
  min-width: 0;
  transition: background 0.12s ease;
}

.patient-profile__table-row:hover > div {
  background: #F8FAFC;
}

.patient-profile__table-row > div.is-action {
  justify-content: flex-end;
}

.patient-profile__stack {
  display: flex;
  flex-direction: column;
  gap: 1px;
  min-width: 0;
}

.patient-profile__stack-title {
  font-weight: 500;
  color: #0F172A;
  line-height: 1.25;
}

.patient-profile__stack-sub {
  font-size: 11px;
  color: #64748B;
  line-height: 1.25;
}

.patient-profile__status {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  height: 22px;
  padding: 0 10px;
  border-radius: 9999px;
  font-size: 11px;
  font-weight: 500;
  border: 1px solid transparent;
  white-space: nowrap;
}

.patient-profile__status-dot {
  width: 6px;
  height: 6px;
  border-radius: 9999px;
  background: currentColor;
  flex-shrink: 0;
}

.patient-profile__status.is-waiting {
  background: #FFFBEB;
  color: #B45309;
  border-color: #FDE68A;
}

.patient-profile__status.is-confirmed {
  background: #ECFDF5;
  color: #047857;
  border-color: #A7F3D0;
}

.patient-profile__status.is-invisit {
  background: #E0F2FE;
  color: #0369A1;
  border-color: #BAE6FD;
}

.patient-profile__status.is-finished {
  background: #ECFDF5;
  color: #047857;
  border-color: #A7F3D0;
}

.patient-profile__status.is-pending,
.patient-profile__status.is-unreached,
.patient-profile__status.is-afterwork,
.patient-profile__status.is-postponed {
  background: #F1F5F9;
  color: #475569;
  border-color: #CBD5E1;
}

.patient-profile__status.is-cancelled {
  background: #FEF2F2;
  color: #B91C1C;
  border-color: #FECACA;
}

.patient-profile__status.is-due {
  background: #FFF1F2;
  color: #BE123C;
  border-color: #FECDD3;
}

.patient-profile__status.is-paid {
  background: #ECFDF5;
  color: #047857;
  border-color: #A7F3D0;
}

.patient-profile__table.is-ledger .patient-profile__receipt-btn {
  height: 28px;
  padding: 0 12px;
  font-size: 12px;
  font-weight: 600;
  border-radius: 8px;
  white-space: nowrap;
  box-shadow: none;
}

.patient-profile__table.is-ledger .is-action {
  justify-content: flex-end;
}

.patient-profile__table.is-ledger .patient-profile__status.is-due,
.patient-profile__table.is-ledger .patient-profile__status.is-paid,
.patient-profile__table.is-ledger .patient-profile__status.is-posted,
.patient-profile__table.is-ledger .patient-profile__status.is-pending {
  height: 24px;
  padding: 0 12px;
  font-size: 11px;
  font-weight: 600;
  white-space: nowrap;
}

.patient-profile__status.is-posted {
  background: #ECFDF5;
  color: #047857;
  border-color: #A7F3D0;
}

.patient-profile__row-link {
  display: inline-flex;
  align-items: center;
  justify-content: flex-end;
  gap: 4px;
  max-width: 88px;
  border: 0;
  background: transparent;
  padding: 0;
  color: #0EA5E9;
  font-size: 12px;
  font-weight: 600;
  font-family: inherit;
  line-height: 1.25;
  text-align: end;
  cursor: pointer;
}

.patient-profile__table.is-journeys .patient-profile__row-link {
  max-width: none;
  white-space: nowrap;
}

.patient-profile__row-link:hover {
  color: #0284C7;
  text-decoration: underline;
}

.patient-profile__pager {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  flex-wrap: wrap;
  padding: 12px 16px;
  border-top: 1px solid #F1F5F9;
  background: rgba(248, 250, 252, 0.4);
  font-size: 12px;
  color: #64748B;
}

.patient-profile__pager-controls {
  display: flex;
  align-items: center;
  gap: 8px;
}

.patient-profile__pager-btn {
  height: 28px;
  padding: 0 10px;
  border-radius: 6px;
  border: 1px solid #E2E8F0;
  background: #ffffff;
  color: #334155;
  font-size: 12px;
  font-family: inherit;
  cursor: pointer;
}

.patient-profile__pager-btn:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}

.patient-profile__pager-num {
  box-sizing: border-box;
  width: 28px;
  height: 28px;
  padding: 0;
  border-radius: 6px;
  border: 1px solid transparent;
  background: transparent;
  color: #475569;
  font-size: 12px;
  font-weight: 600;
  font-family: inherit;
  cursor: pointer;
}

.patient-profile__pager-num.is-current {
  background: #0EA5E9;
  color: #ffffff;
  box-shadow: 0 1px 2px rgba(14, 165, 233, 0.35);
}

.patient-profile__pager-num:hover:not(.is-current) {
  background: #F8FAFC;
}

.patient-profile__pkg-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 16px;
}

.patient-profile__pkg {
  display: grid;
  grid-template-columns: minmax(220px, 1.45fr) minmax(130px, 0.8fr) minmax(170px, 1fr) 96px auto;
  align-items: center;
  gap: 16px;
  padding: 14px 16px;
  border: 1px solid #E2E8F0;
  border-radius: 12px;
  background: #ffffff;
}

.patient-profile__pkg-id {
  display: flex;
  align-items: center;
  gap: 12px;
  min-width: 0;
}

.patient-profile__pkg-icon {
  width: 36px;
  height: 36px;
  border-radius: 10px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  background: #F0F9FF;
  color: #0EA5E9;
  font-size: 16px;
}

.patient-profile__pkg-copy {
  min-width: 0;
}

.patient-profile__pkg-name {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
}

.patient-profile__pkg-name h4 {
  margin: 0;
  font-size: 14px;
  font-weight: 600;
  color: #0F172A;
}

.patient-profile__pkg-copy p {
  margin: 2px 0 0;
  font-size: 12px;
  color: #64748B;
}

.patient-profile__pkg-person {
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
}

.patient-profile__pkg-person span {
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: #94A3B8;
}

.patient-profile__pkg-person strong {
  font-size: 13px;
  font-weight: 600;
  color: #0F172A;
}

.patient-profile__pkg-quota {
  min-width: 0;
}

.patient-profile__pkg-quota-top,
.patient-profile__pkg-quota-foot {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  font-size: 12px;
  color: #64748B;
}

.patient-profile__pkg-quota-top {
  margin-bottom: 6px;
  font-weight: 500;
}

.patient-profile__pkg-quota-top strong {
  font-size: 12px;
  font-weight: 700;
  color: #334155;
}

.patient-profile__pkg-quota-top strong.is-low,
.patient-profile__pkg-quota-foot .is-low {
  color: #E11D48;
  font-weight: 600;
}

.patient-profile__pkg-quota-foot {
  margin-top: 6px;
}

.patient-profile__pkg-price {
  text-align: end;
}

.patient-profile__pkg-price strong {
  font-size: 16px;
  font-weight: 700;
  color: #0F172A;
  font-variant-numeric: tabular-nums;
}

.patient-profile__sessions {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  border: 0;
  background: transparent;
  padding: 0;
  color: #334155;
  font-size: 13px;
  font-weight: 500;
  font-family: inherit;
  white-space: nowrap;
  cursor: pointer;
}

.patient-profile__sessions:hover {
  color: #0EA5E9;
}

[dir='rtl'] .patient-profile__sessions .anticon {
  transform: scaleX(-1);
}

@media (max-width: 980px) {
  .patient-profile__pkg {
    grid-template-columns: 1fr;
  }
}

.patient-profile__meter {
  display: flex;
  flex-direction: column;
  gap: 4px;
  width: 100%;
  min-width: 0;
}

.patient-profile__meter-track {
  height: 6px;
  border-radius: 9999px;
  background: #E2E8F0;
  overflow: hidden;
}

.patient-profile__meter-track > span {
  display: block;
  height: 100%;
  border-radius: inherit;
  background: #0EA5E9;
}

.patient-profile__meter-track.is-done > span {
  background: #10B981;
}

.patient-profile__meter-track.is-low > span {
  background: #E11D48;
}

.patient-profile__inline-progress {
  display: flex;
  align-items: center;
  gap: 10px;
  min-width: 0;
  font-size: 12px;
  color: #475569;
  white-space: nowrap;
}

.patient-profile__inline-progress .patient-profile__meter-track {
  width: 72px;
  flex-shrink: 0;
}

.patient-profile__meter-label {
  font-size: 11px;
  color: #64748B;
  font-variant-numeric: tabular-nums;
}

.patient-profile__ledger-title {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
}

.patient-profile__finance-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 12px;
  padding: 16px;
}

@media (max-width: 800px) {
  .patient-profile__finance-grid {
    grid-template-columns: 1fr;
  }
}

.patient-profile__balance-chip {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  height: 22px;
  padding: 0 10px;
  border-radius: 9999px;
  border: 1px solid #FDE68A;
  background: #FFFBEB;
  color: #D97706;
  font-size: 11px;
  font-weight: 600;
  white-space: nowrap;
}

.patient-profile__balance-chip .patient-profile__status-dot {
  background: #D97706;
}

.patient-profile__filter {
  height: 32px;
  padding: 0 10px;
  border-radius: 6px;
  border: 1px solid #E2E8F0;
  background: #ffffff;
  color: #334155;
  font-size: 12px;
  font-family: inherit;
}

.patient-profile__finance-tile {
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding: 12px;
  border-radius: 8px;
  border: 1px solid #F1F5F9;
  background: #F8FAFC;
}

.patient-profile__finance-tile.is-due {
  border-color: #FDE68A;
  background: #FFFBEB;
}

.patient-profile__finance-tile.is-due .patient-profile__finance-label,
.patient-profile__finance-tile.is-due .patient-profile__finance-value,
.patient-profile__finance-tile.is-due .patient-profile__finance-hint {
  color: #D97706;
}

.patient-profile__finance-label-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.patient-profile__due-dot {
  width: 8px;
  height: 8px;
  border-radius: 9999px;
  background: #D97706;
}

.patient-profile__finance-label {
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: #64748B;
}

.patient-profile__finance-value {
  font-size: 18px;
  font-weight: 700;
  color: #0F172A;
  font-variant-numeric: tabular-nums;
}

.patient-profile__finance-value.is-muted {
  color: #64748B;
}

.patient-profile__finance-hint {
  font-size: 11px;
  color: #64748B;
}

.patient-profile__ledger-empty {
  padding: 28px 16px 20px;
  text-align: center;
  color: #94A3B8;
  font-size: 13px;
  font-weight: 500;
}

.patient-profile__ledger-empty p {
  margin: 0;
}

.patient-profile__balance-card {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin: 20px;
  padding: 20px;
  border-radius: 12px;
  border: 1px solid #E2E8F0;
  background: #F8FAFC;
}

.patient-profile__balance-label {
  font-size: 12px;
  font-weight: 500;
  color: #64748B;
}

.patient-profile__balance-value {
  font-size: 28px;
  font-weight: 700;
  letter-spacing: -0.02em;
  color: #0F172A;
  font-variant-numeric: tabular-nums;
}

/* legacy hooks still referenced elsewhere */
.remove-padding {
  padding-bottom: 0 !important;
}

.patient-info {
  background-color: white;
  padding: 24px;
  border-radius: 12px;
  border: 1px solid #E2E8F0;
  height: 100%;
}

`, "",{"version":3,"sources":["webpack://./src/pages/ShowPatient/style.css"],"names":[],"mappings":"AAAA,wDAAwD;AACxD;EACE,sBAAsB;EACtB,WAAW;EACX,aAAa;EACb,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,MAAM;AACR;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,eAAe;EACf,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,eAAe;EACf,qBAAqB;EACrB,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,QAAQ;EACR,eAAe;EACf,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,6EAA6E;EAC7E,gBAAgB;EAChB,cAAc;EACd,kCAAkC;AACpC;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,sBAAsB;EACtB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,mBAAmB;EACnB,4EAA4E;AAC9E;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,oDAAoD;EACpD,SAAS;EACT,eAAe;AACjB;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE,sBAAsB;EACtB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,YAAY;EACZ,4CAA4C;AAC9C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,oBAAoB;EACpB,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,8BAA8B;EAC9B,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;EACrB,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,YAAY;AACd;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;EACT,YAAY;AACd;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;EACT,YAAY;EACZ,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE;;IAEE,0BAA0B;EAC5B;AACF;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;;EAEE,6EAA6E;EAC7E,kCAAkC;EAClC,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,QAAQ;EACR,WAAW;EACX,sBAAsB;EACtB,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,UAAU;EACV,WAAW;EACX,eAAe;EACf,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,sBAAsB;EACtB,YAAY;EACZ,SAAS;EACT,kBAAkB;EAClB,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,QAAQ;AACV;;AAEA;EACE,SAAS;EACT,eAAe,EAAE,gCAAgC;EACjD,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,SAAS;EACT,UAAU;EACV,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,0BAA0B;AAC5B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,qBAAqB;AACvB;;AAEA,+DAA+D;AAC/D;EACE,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,SAAS;EACT,mBAAmB;EACnB,gCAAgC;EAChC,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,SAAS;EACT,oCAAoC;EACpC,uBAAuB;EACvB,cAAc;EACd,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA,wBAAwB;AACxB;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,YAAY;EACZ,4CAA4C;AAC9C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,eAAe;EACf,aAAa;EACb,gCAAgC;EAChC,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,SAAS;EACT,YAAY;AACd;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,cAAc;EACd,qBAAqB;EACrB,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,QAAQ;EACR,2BAA2B;EAC3B,cAAc;EACd,eAAe;EACf,UAAU;EACV,oBAAoB;AACtB;;AAEA;;EAEE,YAAY;EACZ,uBAAuB;EACvB,qCAAqC;EACrC,6BAA6B;EAC7B,gCAAgC;EAChC,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,oGAAoG;AACtG;;AAEA;EACE,sEAAsE;AACxE;;AAEA;EACE,iFAAiF;AACnF;;AAEA;EACE,gDAAgD;EAChD,gBAAgB;EAChB,MAAM;AACR;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;;EAEE,yBAAyB;EACzB,mBAAmB;EACnB,kCAAkC;AACpC;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;;;;EAIE,uBAAuB;AACzB;;AAEA;;EAEE,yBAAyB;EACzB,wBAAwB;AAC1B;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;EAEE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,gCAAgC;EAChC,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,YAAY;EACZ,iCAAiC;AACnC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,eAAe;EACf,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,qBAAqB;EACrB,wBAAwB;EACxB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;AACvB;;AAEA;;;;EAIE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;;;EAIE,YAAY;EACZ,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,yBAAyB;EACzB,QAAQ;EACR,eAAe;EACf,SAAS;EACT,uBAAuB;EACvB,UAAU;EACV,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,iBAAiB;EACjB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,eAAe;EACf,kBAAkB;EAClB,6BAA6B;EAC7B,oCAAoC;EACpC,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,oBAAoB;EACpB,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,WAAW;EACX,YAAY;EACZ,UAAU;EACV,kBAAkB;EAClB,6BAA6B;EAC7B,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,8CAA8C;AAChD;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,aAAa;AACf;;AAEA;EACE,aAAa;EACb,8FAA8F;EAC9F,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,mBAAmB;EACnB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,YAAY;AACd;;AAEA;;EAEE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;EACR,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;;EAEE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kCAAkC;AACpC;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,SAAS;EACT,uBAAuB;EACvB,UAAU;EACV,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,qBAAqB;EACrB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,YAAY;EACZ,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;EACT,aAAa;AACf;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,eAAe;EACf,qBAAqB;EACrB,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,aAAa;EACb,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;;;EAGE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,UAAU;EACV,WAAW;EACX,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kCAAkC;AACpC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,cAAc;EACd,kCAAkC;AACpC;;AAEA,4CAA4C;AAC5C;EACE,4BAA4B;AAC9B;;AAEA;EACE,uBAAuB;EACvB,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,YAAY;AACd","sourcesContent":["/* ——— Patient profile (Stitch Clinical Precision) ——— */\n.patient-profile {\n  box-sizing: border-box;\n  width: 100%;\n  padding: 32px;\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 0;\n}\n\n.patient-profile__hero {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 16px;\n  flex-wrap: wrap;\n  padding-bottom: 24px;\n  border-bottom: 1px solid #E2E8F0;\n}\n\n.patient-profile__hero-left {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  min-width: 0;\n}\n\n.patient-profile__avatar-wrap {\n  position: relative;\n  flex-shrink: 0;\n}\n\n.patient-profile__avatar {\n  width: 56px;\n  height: 56px;\n  border-radius: 9999px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: #E0F2FE;\n  color: #0EA5E9;\n  font-size: 18px;\n  font-weight: 700;\n  border: 2px solid #ffffff;\n  box-shadow: 0 0 0 2px #BAE6FD;\n}\n\n.patient-profile__avatar-dot {\n  position: absolute;\n  right: 0;\n  bottom: 0;\n  width: 14px;\n  height: 14px;\n  border-radius: 9999px;\n  background: #10B981;\n  border: 2px solid #ffffff;\n}\n\n.patient-profile__hero-text {\n  min-width: 0;\n}\n\n.patient-profile__title-row {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  flex-wrap: wrap;\n}\n\n.patient-profile__name {\n  margin: 0;\n  font-size: 24px;\n  font-weight: 700;\n  letter-spacing: -0.02em;\n  color: #0F172A;\n  line-height: 1.2;\n}\n\n.patient-profile__active {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  height: 22px;\n  padding: 0 10px;\n  border-radius: 9999px;\n  border: 1px solid #A7F3D0;\n  background: #ECFDF5;\n  color: #047857;\n  font-size: 12px;\n  font-weight: 500;\n}\n\n.patient-profile__active-dot {\n  width: 6px;\n  height: 6px;\n  border-radius: 9999px;\n  background: #10B981;\n}\n\n.patient-profile__meta {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 6px;\n  margin-top: 4px;\n  font-size: 13px;\n  color: #64748B;\n}\n\n.patient-profile__meta-sep {\n  color: #94A3B8;\n}\n\n.patient-profile__meta-mono {\n  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;\n  font-weight: 500;\n  color: #334155;\n  font-variant-numeric: tabular-nums;\n}\n\n.patient-profile__meta-place {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n}\n\n.patient-profile__meta-place .anticon {\n  color: #94A3B8;\n  font-size: 15px;\n}\n\n.patient-profile__hero-actions {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  flex-wrap: wrap;\n  flex-shrink: 0;\n}\n\n.patient-profile__btn {\n  box-sizing: border-box;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  height: 36px;\n  padding: 0 14px;\n  border-radius: 8px;\n  font-size: 13px;\n  font-weight: 600;\n  font-family: inherit;\n  cursor: pointer;\n  white-space: nowrap;\n  transition: background 0.12s ease, border-color 0.12s ease, color 0.12s ease;\n}\n\n.patient-profile__btn--sm {\n  height: 32px;\n  padding: 0 12px;\n  font-size: 12px;\n}\n\n.patient-profile__btn--secondary {\n  border: 1px solid #E2E8F0;\n  background: #ffffff;\n  color: #334155;\n}\n\n.patient-profile__btn--secondary:hover {\n  background: #F8FAFC;\n  border-color: #CBD5E1;\n}\n\n.patient-profile__btn--soft {\n  border: 1px solid #BAE6FD;\n  background: #F0F9FF;\n  color: #0EA5E9;\n}\n\n.patient-profile__btn--soft:hover {\n  background: #E0F2FE;\n}\n\n.patient-profile__btn--primary {\n  border: 1px solid #0EA5E9;\n  background: #0EA5E9;\n  color: #ffffff;\n}\n\n.patient-profile__btn--primary:hover {\n  background: #0284C7;\n  border-color: #0284C7;\n}\n\n.patient-profile__cards {\n  display: grid;\n  grid-template-columns: minmax(0, 2fr) minmax(0, 3fr);\n  gap: 20px;\n  padding: 24px 0;\n}\n\n@media (max-width: 960px) {\n  .patient-profile {\n    padding: 16px;\n  }\n\n  .patient-profile__cards {\n    grid-template-columns: 1fr;\n  }\n}\n\n.patient-profile__card {\n  box-sizing: border-box;\n  background: #ffffff;\n  border: 1px solid #E2E8F0;\n  border-radius: 12px;\n  padding: 20px;\n  min-width: 0;\n  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04);\n}\n\n.patient-profile__card-head {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  padding-bottom: 14px;\n  margin-bottom: 14px;\n  border-bottom: 1px solid #F1F5F9;\n}\n\n.patient-profile__card-title {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  min-width: 0;\n}\n\n.patient-profile__card-title h2 {\n  margin: 0;\n  font-size: 14px;\n  font-weight: 600;\n  color: #0F172A;\n}\n\n.patient-profile__card-icon {\n  width: 28px;\n  height: 28px;\n  border-radius: 8px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  font-size: 14px;\n}\n\n.patient-profile__card-icon.is-sky {\n  background: #F0F9FF;\n  color: #0EA5E9;\n}\n\n.patient-profile__card-icon.is-rose {\n  background: #FFF1F2;\n  color: #E11D48;\n}\n\n.patient-profile__card-icon.is-emerald {\n  background: #ECFDF5;\n  color: #059669;\n}\n\n.patient-profile__card-badge {\n  font-size: 11px;\n  font-weight: 600;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n  color: #94A3B8;\n  white-space: nowrap;\n}\n\n.patient-profile__rows {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.patient-profile__row {\n  display: flex;\n  align-items: baseline;\n  justify-content: space-between;\n  gap: 16px;\n  font-size: 13px;\n}\n\n.patient-profile__row-label {\n  color: #64748B;\n  flex-shrink: 0;\n}\n\n.patient-profile__row-value {\n  font-weight: 500;\n  color: #0F172A;\n  text-align: end;\n  min-width: 0;\n  word-break: break-word;\n}\n\n.patient-profile__multiline {\n  white-space: pre-wrap;\n  overflow-wrap: anywhere;\n  word-break: break-word;\n}\n\n.patient-profile__clinical {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  min-width: 0;\n}\n\n.patient-profile__vitals {\n  display: grid;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  gap: 16px;\n  min-width: 0;\n}\n\n.patient-profile__vital-value {\n  margin: 0;\n  font-size: 14px;\n  font-weight: 600;\n  color: #0F172A;\n}\n\n.patient-profile__clinical-pair {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 16px;\n  min-width: 0;\n  align-items: stretch;\n}\n\n.patient-profile__clinical-block {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  min-width: 0;\n}\n\n@media (max-width: 640px) {\n  .patient-profile__vitals,\n  .patient-profile__clinical-pair {\n    grid-template-columns: 1fr;\n  }\n}\n\n.patient-profile__clinical-label {\n  font-size: 12px;\n  font-weight: 500;\n  color: #94A3B8;\n}\n\n.patient-profile__clinical-empty {\n  margin: 0;\n  font-size: 13px;\n  font-weight: 500;\n  color: #94A3B8;\n}\n\n.patient-profile__row-value.is-mono,\n.patient-profile__mono {\n  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;\n  font-variant-numeric: tabular-nums;\n  font-weight: 500;\n  color: #334155;\n}\n\n.patient-profile__mono.is-strong {\n  color: #0F172A;\n}\n\n.patient-profile__row-value.is-muted {\n  color: #94A3B8;\n  font-weight: 500;\n}\n\n.patient-profile__row-value.is-chip {\n  flex-shrink: 0;\n  padding: 2px 8px;\n  border-radius: 6px;\n  border: 1px solid #E2E8F0;\n  background: #F8FAFC;\n  font-size: 12px;\n  color: #0F172A;\n}\n\n.patient-profile__alert {\n  display: flex;\n  align-items: flex-start;\n  gap: 8px;\n  width: 100%;\n  box-sizing: border-box;\n  min-width: 0;\n  padding: 10px 12px;\n  border-radius: 8px;\n  border: 1px solid #FDE68A;\n  background: #FFFBEB;\n  color: #B45309;\n  font-size: 12px;\n  font-weight: 500;\n  line-height: 1.5;\n}\n\n.patient-profile__alert-text {\n  margin: 0;\n}\n\n.patient-profile__alert-dot {\n  width: 6px;\n  height: 6px;\n  margin-top: 6px;\n  border-radius: 9999px;\n  background: #F59E0B;\n  flex-shrink: 0;\n}\n\n.patient-profile__med-block {\n  width: 100%;\n  box-sizing: border-box;\n  min-width: 0;\n  margin: 0;\n  padding: 10px 12px;\n  border-radius: 8px;\n  border: 1px solid #E2E8F0;\n  background: #F8FAFC;\n  color: #0F172A;\n  font-size: 12px;\n  font-weight: 500;\n  line-height: 1.5;\n}\n\n.patient-profile__clamp {\n  flex: 1 1 auto;\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 6px;\n}\n\n.patient-profile__clamp-body {\n  margin: 0;\n  max-height: 3em; /* ~2 lines at 1.5 line-height */\n  overflow: hidden;\n}\n\n.patient-profile__clamp-body.is-expanded {\n  max-height: none;\n  overflow: visible;\n}\n\n.patient-profile__clamp-toggle {\n  border: 0;\n  padding: 0;\n  background: transparent;\n  color: #0EA5E9;\n  font-size: 12px;\n  font-weight: 700;\n  font-family: inherit;\n  cursor: pointer;\n  line-height: 1.2;\n  text-decoration: underline;\n  text-underline-offset: 2px;\n}\n\n.patient-profile__clamp-toggle:hover {\n  color: #0284C7;\n}\n\n.patient-profile__alert .patient-profile__clamp-toggle {\n  color: #D97706;\n}\n\n.patient-profile__alert .patient-profile__clamp-toggle:hover {\n  color: #B45309;\n}\n\n.patient-profile__notes {\n  padding-top: 8px;\n  border-top: 1px solid #F1F5F9;\n}\n\n.patient-profile__notes-label {\n  display: block;\n  margin-bottom: 6px;\n  font-size: 12px;\n  font-weight: 500;\n  color: #94A3B8;\n}\n\n.patient-profile__notes-body {\n  padding: 10px;\n  border-radius: 8px;\n  border: 1px solid #F1F5F9;\n  background: #F8FAFC;\n  font-size: 12px;\n  line-height: 1.5;\n  color: #334155;\n  white-space: pre-wrap;\n}\n\n/* Tabs — Stitch underline bar, not the shared Ant tab chrome */\n.patient-profile__tabs {\n  min-width: 0;\n  padding-top: 8px;\n}\n\n.patient-profile__tabbar {\n  display: flex;\n  align-items: flex-end;\n  gap: 24px;\n  margin-bottom: 20px;\n  border-bottom: 1px solid #E2E8F0;\n  overflow-x: auto;\n  overflow-y: hidden;\n}\n\n.patient-profile__tabbar > button {\n  appearance: none;\n  margin: 0 0 -1px;\n  padding: 0 0 12px;\n  border: 0;\n  border-bottom: 2px solid transparent;\n  background: transparent;\n  color: #64748B;\n  font-family: inherit;\n  font-size: 14px;\n  font-weight: 500;\n  line-height: 1.25;\n  white-space: nowrap;\n  cursor: pointer;\n}\n\n.patient-profile__tabbar > button:hover {\n  color: #1E293B;\n}\n\n.patient-profile__tabbar > button.is-active {\n  color: #0EA5E9;\n  font-weight: 600;\n  border-bottom-color: #0EA5E9;\n}\n\n.patient-profile__tab-label {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.patient-profile__tab-badge {\n  display: inline-flex;\n  align-items: center;\n  padding: 2px 8px;\n  border-radius: 9999px;\n  background: #F1F5F9;\n  color: #475569;\n  font-size: 11px;\n  font-weight: 500;\n  line-height: 1.3;\n  letter-spacing: 0;\n  text-transform: none;\n}\n\n.patient-profile__tabbar > button.is-active .patient-profile__tab-badge {\n  background: #E0F2FE;\n  color: #0369A1;\n  font-weight: 600;\n}\n\n.patient-profile__tab-panel {\n  min-width: 0;\n}\n\n.patient-profile__tab-panel[hidden] {\n  display: none;\n}\n\n/* Tab panels / tables */\n.patient-profile__panel {\n  background: #ffffff;\n  border: 1px solid #E2E8F0;\n  border-radius: 12px;\n  overflow: hidden;\n  min-width: 0;\n  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04);\n}\n\n.patient-profile__panel-head {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  flex-wrap: wrap;\n  padding: 16px;\n  border-bottom: 1px solid #F1F5F9;\n  background: rgba(248, 250, 252, 0.7);\n}\n\n.patient-profile__panel-title {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 10px;\n  min-width: 0;\n}\n\n.patient-profile__panel-title h3 {\n  margin: 0;\n  font-size: 14px;\n  font-weight: 600;\n  color: #0F172A;\n}\n\n.patient-profile__panel-title .patient-profile__card-icon {\n  width: 32px;\n  height: 32px;\n}\n\n.patient-profile__count-pill {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  height: 22px;\n  padding: 0 8px;\n  border-radius: 9999px;\n  border: 1px solid #A7F3D0;\n  background: #ECFDF5;\n  color: #047857;\n  font-size: 11px;\n  font-weight: 600;\n  white-space: nowrap;\n}\n\n.patient-profile__count-pill .patient-profile__status-dot {\n  background: #10B981;\n}\n\n.patient-profile__panel-tools {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  flex-wrap: wrap;\n}\n\n.patient-profile__panel-search {\n  position: relative;\n}\n\n.patient-profile__panel-search-icon {\n  position: absolute;\n  inset-inline-start: 10px;\n  top: 50%;\n  transform: translateY(-50%);\n  color: #94A3B8;\n  font-size: 14px;\n  z-index: 1;\n  pointer-events: none;\n}\n\n.patient-profile__panel-search-input.ant-input,\n.patient-profile__panel-search-input.ant-input-affix-wrapper {\n  width: 200px;\n  height: 32px !important;\n  padding-inline-start: 30px !important;\n  border-radius: 6px !important;\n  border-color: #E2E8F0 !important;\n  font-size: 12px;\n}\n\n.patient-profile__panel-body {\n  min-height: 80px;\n}\n\n.patient-profile__empty {\n  padding: 32px 20px;\n  text-align: center;\n  color: #94A3B8;\n}\n\n.patient-profile__empty p {\n  margin: 8px 0 0;\n  font-size: 13px;\n  font-weight: 500;\n}\n\n.patient-profile__table-scroll {\n  width: 100%;\n  overflow-x: auto;\n}\n\n.patient-profile__table {\n  display: grid;\n  width: 100%;\n  min-width: 760px;\n  font-size: 13px;\n}\n\n.patient-profile__table.is-visits {\n  grid-template-columns: 88px minmax(140px, 1.1fr) minmax(160px, 1.2fr) minmax(160px, 1fr) 130px 110px;\n}\n\n.patient-profile__table.is-packages {\n  grid-template-columns: 100px minmax(140px, 1.4fr) 120px 90px 90px 88px;\n}\n\n.patient-profile__table.is-journeys {\n  grid-template-columns: 88px minmax(160px, 1.1fr) minmax(180px, 1.2fr) 140px 130px;\n}\n\n.patient-profile__table.is-ledger {\n  grid-template-columns: repeat(6, minmax(0, 1fr));\n  min-width: 920px;\n  gap: 0;\n}\n\n.patient-profile__table.is-ledger .patient-profile__table-head > div {\n  min-height: 36px;\n  padding: 8px 16px;\n}\n\n.patient-profile__table.is-ledger .patient-profile__table-row {\n  cursor: default;\n}\n\n.patient-profile__table.is-ledger .patient-profile__table-row > div {\n  min-height: 40px;\n  padding: 8px 16px;\n  line-height: 1.3;\n}\n\n.patient-profile__table.is-ledger .patient-profile__table-head > div:nth-child(3),\n.patient-profile__table.is-ledger .patient-profile__table-row > div.is-amount {\n  justify-content: flex-end;\n  white-space: nowrap;\n  font-variant-numeric: tabular-nums;\n}\n\n.patient-profile__table.is-ledger .is-amount-value {\n  white-space: nowrap;\n  display: inline-block;\n}\n\n.patient-profile__table.is-ledger .patient-profile__table-head > div:nth-child(4),\n.patient-profile__table.is-ledger .patient-profile__table-row > div.is-type,\n.patient-profile__table.is-ledger .patient-profile__table-head > div:nth-child(5),\n.patient-profile__table.is-ledger .patient-profile__table-row > div.is-status {\n  justify-content: center;\n}\n\n.patient-profile__table.is-ledger .patient-profile__table-head > div:nth-child(6),\n.patient-profile__table.is-ledger .patient-profile__table-row > div.is-action {\n  justify-content: flex-end;\n  padding-inline-end: 16px;\n}\n\n.patient-profile__table-row.is-highlight > div {\n  background: rgba(255, 251, 235, 0.55);\n}\n\n.patient-profile__table-row.is-highlight:hover > div {\n  background: #FFFBEB;\n}\n\n.patient-profile__table-head,\n.patient-profile__table-row {\n  display: grid;\n  grid-template-columns: subgrid;\n  grid-column: 1 / -1;\n}\n\n.patient-profile__table-head {\n  border-bottom: 1px solid #F1F5F9;\n  background: rgba(248, 250, 252, 0.85);\n}\n\n.patient-profile__table-head > div {\n  display: flex;\n  align-items: center;\n  min-height: 36px;\n  padding: 8px 16px;\n  font-size: 11px;\n  font-weight: 700;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n  color: #64748B;\n}\n\n.patient-profile__table-row {\n  cursor: pointer;\n  border-bottom: 1px solid #F1F5F9;\n}\n\n.patient-profile__table-row:last-child {\n  border-bottom: 0;\n}\n\n.patient-profile__table-row > div {\n  display: flex;\n  align-items: center;\n  min-height: 44px;\n  padding: 8px 16px;\n  color: #334155;\n  min-width: 0;\n  transition: background 0.12s ease;\n}\n\n.patient-profile__table-row:hover > div {\n  background: #F8FAFC;\n}\n\n.patient-profile__table-row > div.is-action {\n  justify-content: flex-end;\n}\n\n.patient-profile__stack {\n  display: flex;\n  flex-direction: column;\n  gap: 1px;\n  min-width: 0;\n}\n\n.patient-profile__stack-title {\n  font-weight: 500;\n  color: #0F172A;\n  line-height: 1.25;\n}\n\n.patient-profile__stack-sub {\n  font-size: 11px;\n  color: #64748B;\n  line-height: 1.25;\n}\n\n.patient-profile__status {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  height: 22px;\n  padding: 0 10px;\n  border-radius: 9999px;\n  font-size: 11px;\n  font-weight: 500;\n  border: 1px solid transparent;\n  white-space: nowrap;\n}\n\n.patient-profile__status-dot {\n  width: 6px;\n  height: 6px;\n  border-radius: 9999px;\n  background: currentColor;\n  flex-shrink: 0;\n}\n\n.patient-profile__status.is-waiting {\n  background: #FFFBEB;\n  color: #B45309;\n  border-color: #FDE68A;\n}\n\n.patient-profile__status.is-confirmed {\n  background: #ECFDF5;\n  color: #047857;\n  border-color: #A7F3D0;\n}\n\n.patient-profile__status.is-invisit {\n  background: #E0F2FE;\n  color: #0369A1;\n  border-color: #BAE6FD;\n}\n\n.patient-profile__status.is-finished {\n  background: #ECFDF5;\n  color: #047857;\n  border-color: #A7F3D0;\n}\n\n.patient-profile__status.is-pending,\n.patient-profile__status.is-unreached,\n.patient-profile__status.is-afterwork,\n.patient-profile__status.is-postponed {\n  background: #F1F5F9;\n  color: #475569;\n  border-color: #CBD5E1;\n}\n\n.patient-profile__status.is-cancelled {\n  background: #FEF2F2;\n  color: #B91C1C;\n  border-color: #FECACA;\n}\n\n.patient-profile__status.is-due {\n  background: #FFF1F2;\n  color: #BE123C;\n  border-color: #FECDD3;\n}\n\n.patient-profile__status.is-paid {\n  background: #ECFDF5;\n  color: #047857;\n  border-color: #A7F3D0;\n}\n\n.patient-profile__table.is-ledger .patient-profile__receipt-btn {\n  height: 28px;\n  padding: 0 12px;\n  font-size: 12px;\n  font-weight: 600;\n  border-radius: 8px;\n  white-space: nowrap;\n  box-shadow: none;\n}\n\n.patient-profile__table.is-ledger .is-action {\n  justify-content: flex-end;\n}\n\n.patient-profile__table.is-ledger .patient-profile__status.is-due,\n.patient-profile__table.is-ledger .patient-profile__status.is-paid,\n.patient-profile__table.is-ledger .patient-profile__status.is-posted,\n.patient-profile__table.is-ledger .patient-profile__status.is-pending {\n  height: 24px;\n  padding: 0 12px;\n  font-size: 11px;\n  font-weight: 600;\n  white-space: nowrap;\n}\n\n.patient-profile__status.is-posted {\n  background: #ECFDF5;\n  color: #047857;\n  border-color: #A7F3D0;\n}\n\n.patient-profile__row-link {\n  display: inline-flex;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 4px;\n  max-width: 88px;\n  border: 0;\n  background: transparent;\n  padding: 0;\n  color: #0EA5E9;\n  font-size: 12px;\n  font-weight: 600;\n  font-family: inherit;\n  line-height: 1.25;\n  text-align: end;\n  cursor: pointer;\n}\n\n.patient-profile__table.is-journeys .patient-profile__row-link {\n  max-width: none;\n  white-space: nowrap;\n}\n\n.patient-profile__row-link:hover {\n  color: #0284C7;\n  text-decoration: underline;\n}\n\n.patient-profile__pager {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  flex-wrap: wrap;\n  padding: 12px 16px;\n  border-top: 1px solid #F1F5F9;\n  background: rgba(248, 250, 252, 0.4);\n  font-size: 12px;\n  color: #64748B;\n}\n\n.patient-profile__pager-controls {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.patient-profile__pager-btn {\n  height: 28px;\n  padding: 0 10px;\n  border-radius: 6px;\n  border: 1px solid #E2E8F0;\n  background: #ffffff;\n  color: #334155;\n  font-size: 12px;\n  font-family: inherit;\n  cursor: pointer;\n}\n\n.patient-profile__pager-btn:disabled {\n  opacity: 0.4;\n  cursor: not-allowed;\n}\n\n.patient-profile__pager-num {\n  box-sizing: border-box;\n  width: 28px;\n  height: 28px;\n  padding: 0;\n  border-radius: 6px;\n  border: 1px solid transparent;\n  background: transparent;\n  color: #475569;\n  font-size: 12px;\n  font-weight: 600;\n  font-family: inherit;\n  cursor: pointer;\n}\n\n.patient-profile__pager-num.is-current {\n  background: #0EA5E9;\n  color: #ffffff;\n  box-shadow: 0 1px 2px rgba(14, 165, 233, 0.35);\n}\n\n.patient-profile__pager-num:hover:not(.is-current) {\n  background: #F8FAFC;\n}\n\n.patient-profile__pkg-list {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  padding: 16px;\n}\n\n.patient-profile__pkg {\n  display: grid;\n  grid-template-columns: minmax(220px, 1.45fr) minmax(130px, 0.8fr) minmax(170px, 1fr) 96px auto;\n  align-items: center;\n  gap: 16px;\n  padding: 14px 16px;\n  border: 1px solid #E2E8F0;\n  border-radius: 12px;\n  background: #ffffff;\n}\n\n.patient-profile__pkg-id {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  min-width: 0;\n}\n\n.patient-profile__pkg-icon {\n  width: 36px;\n  height: 36px;\n  border-radius: 10px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  background: #F0F9FF;\n  color: #0EA5E9;\n  font-size: 16px;\n}\n\n.patient-profile__pkg-copy {\n  min-width: 0;\n}\n\n.patient-profile__pkg-name {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 8px;\n}\n\n.patient-profile__pkg-name h4 {\n  margin: 0;\n  font-size: 14px;\n  font-weight: 600;\n  color: #0F172A;\n}\n\n.patient-profile__pkg-copy p {\n  margin: 2px 0 0;\n  font-size: 12px;\n  color: #64748B;\n}\n\n.patient-profile__pkg-person {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  min-width: 0;\n}\n\n.patient-profile__pkg-person span {\n  font-size: 10px;\n  font-weight: 700;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n  color: #94A3B8;\n}\n\n.patient-profile__pkg-person strong {\n  font-size: 13px;\n  font-weight: 600;\n  color: #0F172A;\n}\n\n.patient-profile__pkg-quota {\n  min-width: 0;\n}\n\n.patient-profile__pkg-quota-top,\n.patient-profile__pkg-quota-foot {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n  font-size: 12px;\n  color: #64748B;\n}\n\n.patient-profile__pkg-quota-top {\n  margin-bottom: 6px;\n  font-weight: 500;\n}\n\n.patient-profile__pkg-quota-top strong {\n  font-size: 12px;\n  font-weight: 700;\n  color: #334155;\n}\n\n.patient-profile__pkg-quota-top strong.is-low,\n.patient-profile__pkg-quota-foot .is-low {\n  color: #E11D48;\n  font-weight: 600;\n}\n\n.patient-profile__pkg-quota-foot {\n  margin-top: 6px;\n}\n\n.patient-profile__pkg-price {\n  text-align: end;\n}\n\n.patient-profile__pkg-price strong {\n  font-size: 16px;\n  font-weight: 700;\n  color: #0F172A;\n  font-variant-numeric: tabular-nums;\n}\n\n.patient-profile__sessions {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  border: 0;\n  background: transparent;\n  padding: 0;\n  color: #334155;\n  font-size: 13px;\n  font-weight: 500;\n  font-family: inherit;\n  white-space: nowrap;\n  cursor: pointer;\n}\n\n.patient-profile__sessions:hover {\n  color: #0EA5E9;\n}\n\n[dir='rtl'] .patient-profile__sessions .anticon {\n  transform: scaleX(-1);\n}\n\n@media (max-width: 980px) {\n  .patient-profile__pkg {\n    grid-template-columns: 1fr;\n  }\n}\n\n.patient-profile__meter {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  width: 100%;\n  min-width: 0;\n}\n\n.patient-profile__meter-track {\n  height: 6px;\n  border-radius: 9999px;\n  background: #E2E8F0;\n  overflow: hidden;\n}\n\n.patient-profile__meter-track > span {\n  display: block;\n  height: 100%;\n  border-radius: inherit;\n  background: #0EA5E9;\n}\n\n.patient-profile__meter-track.is-done > span {\n  background: #10B981;\n}\n\n.patient-profile__meter-track.is-low > span {\n  background: #E11D48;\n}\n\n.patient-profile__inline-progress {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  min-width: 0;\n  font-size: 12px;\n  color: #475569;\n  white-space: nowrap;\n}\n\n.patient-profile__inline-progress .patient-profile__meter-track {\n  width: 72px;\n  flex-shrink: 0;\n}\n\n.patient-profile__meter-label {\n  font-size: 11px;\n  color: #64748B;\n  font-variant-numeric: tabular-nums;\n}\n\n.patient-profile__ledger-title {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 8px;\n}\n\n.patient-profile__finance-grid {\n  display: grid;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  gap: 12px;\n  padding: 16px;\n}\n\n@media (max-width: 800px) {\n  .patient-profile__finance-grid {\n    grid-template-columns: 1fr;\n  }\n}\n\n.patient-profile__balance-chip {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  height: 22px;\n  padding: 0 10px;\n  border-radius: 9999px;\n  border: 1px solid #FDE68A;\n  background: #FFFBEB;\n  color: #D97706;\n  font-size: 11px;\n  font-weight: 600;\n  white-space: nowrap;\n}\n\n.patient-profile__balance-chip .patient-profile__status-dot {\n  background: #D97706;\n}\n\n.patient-profile__filter {\n  height: 32px;\n  padding: 0 10px;\n  border-radius: 6px;\n  border: 1px solid #E2E8F0;\n  background: #ffffff;\n  color: #334155;\n  font-size: 12px;\n  font-family: inherit;\n}\n\n.patient-profile__finance-tile {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  padding: 12px;\n  border-radius: 8px;\n  border: 1px solid #F1F5F9;\n  background: #F8FAFC;\n}\n\n.patient-profile__finance-tile.is-due {\n  border-color: #FDE68A;\n  background: #FFFBEB;\n}\n\n.patient-profile__finance-tile.is-due .patient-profile__finance-label,\n.patient-profile__finance-tile.is-due .patient-profile__finance-value,\n.patient-profile__finance-tile.is-due .patient-profile__finance-hint {\n  color: #D97706;\n}\n\n.patient-profile__finance-label-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.patient-profile__due-dot {\n  width: 8px;\n  height: 8px;\n  border-radius: 9999px;\n  background: #D97706;\n}\n\n.patient-profile__finance-label {\n  font-size: 11px;\n  font-weight: 600;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n  color: #64748B;\n}\n\n.patient-profile__finance-value {\n  font-size: 18px;\n  font-weight: 700;\n  color: #0F172A;\n  font-variant-numeric: tabular-nums;\n}\n\n.patient-profile__finance-value.is-muted {\n  color: #64748B;\n}\n\n.patient-profile__finance-hint {\n  font-size: 11px;\n  color: #64748B;\n}\n\n.patient-profile__ledger-empty {\n  padding: 28px 16px 20px;\n  text-align: center;\n  color: #94A3B8;\n  font-size: 13px;\n  font-weight: 500;\n}\n\n.patient-profile__ledger-empty p {\n  margin: 0;\n}\n\n.patient-profile__balance-card {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  margin: 20px;\n  padding: 20px;\n  border-radius: 12px;\n  border: 1px solid #E2E8F0;\n  background: #F8FAFC;\n}\n\n.patient-profile__balance-label {\n  font-size: 12px;\n  font-weight: 500;\n  color: #64748B;\n}\n\n.patient-profile__balance-value {\n  font-size: 28px;\n  font-weight: 700;\n  letter-spacing: -0.02em;\n  color: #0F172A;\n  font-variant-numeric: tabular-nums;\n}\n\n/* legacy hooks still referenced elsewhere */\n.remove-padding {\n  padding-bottom: 0 !important;\n}\n\n.patient-info {\n  background-color: white;\n  padding: 24px;\n  border-radius: 12px;\n  border: 1px solid #E2E8F0;\n  height: 100%;\n}\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
